import PropTypes from "prop-types"
import React from "react"
import { Collapse } from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"
import isPermissionEnabled from "common/isPermissionEnabled"
import usePermissionRefresh from "hooks/usePermissionRefresh"
import {
  SUPERADMIN_NAV_LINKS,
  getSuperAdminActiveNavHref,
  resolveSuperAdminMenuPath,
} from "components/SuperAdmin/superadminNav"

/**
 * Horizontal menu strip for Super Admin only — tenants use {@link HorizontalLayout/Navbar}.
 */
const SuperAdminHorizontalNavbar = props => {
  const { pathname } = useLocation()
  const { userRole, accountType, accountScope } = useSelector(state => state.Login)

  usePermissionRefresh()

  const platformActiveHref = getSuperAdminActiveNavHref(pathname)
  const activeMenuPath = resolveSuperAdminMenuPath(pathname)

  return (
    <div className="topnav">
      <div className="container-fluid">
        <nav
          className="navbar navbar-light navbar-expand-lg topnav-menu horizontal_navbar horizontal_navbar--platform"
          id="navigation"
        >
          <Collapse
            isOpen={props.leftMenu}
            className="navbar-collapse w-100"
            id="topnav-menu-content"
          >
            <div className="hover-list-container" style={{ maxWidth: "100%" }}>
              <ul className="navbar-nav" style={{ overflow: "auto" }}>
                {SUPERADMIN_NAV_LINKS.map(item => {
                  const { path, icon, titleKey, children = [], permission } = item
                  const visibleChildren = children.filter(child =>
                    !child.permission ||
                    isPermissionEnabled(
                      userRole,
                      child.permission.categoryId,
                      child.permission.permissionId,
                      accountType,
                      accountScope
                    )
                  )
                  const parentAllowed =
                    !permission ||
                    isPermissionEnabled(
                      userRole,
                      permission.categoryId,
                      permission.permissionId,
                      accountType,
                      accountScope
                    ) ||
                    visibleChildren.length > 0

                  if (!parentAllowed) {
                    return null
                  }

                  const isUsersSection = path === "/superadmin/users"
                  const isActive =
                    platformActiveHref === path ||
                    (isUsersSection && pathname.startsWith("/superadmin/users"))

                  if (visibleChildren.length > 0) {
                    return (
                      <li
                        key={path}
                        className={`nav-item dropdown${isActive ? " active" : ""}`}
                      >
                        <Link
                          className={`nav-link dropdown-toggle arrow-none${
                            isActive ? " active" : ""
                          }`}
                          to="#"
                          data-bs-toggle="dropdown"
                          role="button"
                          aria-expanded="false"
                        >
                          <i className={`${icon} me-2`}></i>
                          {props.t(titleKey)}
                        </Link>
                        <div className="dropdown-menu">
                          {visibleChildren.map(child => (
                            <Link
                              key={child.path}
                              className={`dropdown-item${
                                activeMenuPath === child.path ? " active" : ""
                              }`}
                              to={child.path}
                            >
                              {props.t(child.titleKey)}
                            </Link>
                          ))}
                        </div>
                      </li>
                    )
                  }

                  return (
                    <li
                      key={path}
                      className={`nav-item dropdown${isActive ? " active" : ""}`}
                    >
                      <Link
                        className={`nav-link dropdown-toggle arrow-none${
                          isActive ? " active" : ""
                        }`}
                        to={path}
                      >
                        <i className={`${icon} me-2`}></i>
                        {props.t(titleKey)}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </Collapse>
        </nav>
      </div>
    </div>
  )
}

SuperAdminHorizontalNavbar.propTypes = {
  leftMenu: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default connect(mapStatetoProps, {})(
  withTranslation()(SuperAdminHorizontalNavbar)
)
